import { FC } from "react";
import { Form, useFormikContext } from "formik";
import classNames from "classnames";
import { GridCol } from "@design-system/Grid/GridCol";
import { GridRow } from "@design-system/Grid/GridRow";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { EnterKeyHint } from "@components/onboarding/components/EnterKeyHint";
import animation from "../layout/OnboardingLayout.module.scss";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import fieldSpacing from "../components/fieldSpacing.module.scss";
import type { InviteUserProfileFlowFormSchema } from "../lib";
import styles from "./Profile.module.scss";
import commonStyles from "./common.module.scss";

const fields = createFormikFields<InviteUserProfileFlowFormSchema>();

interface Props {
    busy: boolean;
}

export const InviteProfile: FC<Props> = ({ busy }) => {
    const { isValid } = useFormikContext();
    return (
        <div className={commonStyles.content420}>
            <header className={animation.fadeIn2}>
                <h1
                    className={classNames(
                        commonStyles.title,
                        styles.header,
                        "mb-5",
                    )}
                >
                    Finish setting up your account
                </h1>
            </header>

            <Form className={animation.fadeIn1}>
                <GridRow>
                    <GridCol sm={6}>
                        <fields.Text
                            name="firstName"
                            label="First name"
                            size="xl"
                            className={fieldSpacing.inputField}
                        />
                    </GridCol>

                    <GridCol sm={6}>
                        <fields.Text
                            name="lastName"
                            label="Last name"
                            size="xl"
                            className={fieldSpacing.inputField}
                        />
                    </GridCol>
                </GridRow>

                <footer>
                    <ButtonWithLoader
                        type="submit"
                        variant="primary"
                        loading={busy}
                        disabled={!isValid}
                        size="xl"
                        block
                        className="mt-3"
                        rightIcon={<EnterKeyHint />}
                    >
                        Submit
                    </ButtonWithLoader>
                </footer>
            </Form>
        </div>
    );
};
